module.exports = {"110118001":"鼓楼街道","110118002":"果园街道","110118003":"檀营地区","110118100":"密云镇","110118101":"溪翁庄镇","110118102":"西田各庄镇","110118103":"十里堡镇","110118104":"河南寨镇","110118105":"巨各庄镇","110118106":"穆家峪镇","110118107":"太师屯镇","110118108":"高岭镇","110118109":"不老屯镇","110118110":"冯家峪镇","110118111":"古北口镇","110118112":"大城子镇","110118113":"东邵渠镇","110118114":"北庄镇","110118115":"新城子镇","110118116":"石城镇","110118400":"中关村科技园区密云园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110118.json
// module id = 121
// module chunks = 0